import type { Metadata } from "next";
import { AboutView } from "@/components/about/about-view";
import { site } from "@/content/site";

export const metadata: Metadata = {
  title: { absolute: "About Quto AI — The AI Agents Agency" },
  description:
    "Quto AI is a done-for-you AI agents agency. We design, build and deploy conversational AI agents across voice, WhatsApp, chat and web.",
  alternates: { canonical: "/about" },
  openGraph: {
    title: "About Quto AI — The AI Agents Agency",
    description:
      "How Quto AI designs, builds and deploys AI agents for real business conversations.",
  },
};

export default function AboutPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: site.name,
    url: site.url,
    logo: `${site.url}/images/bot-logo.png`,
    description: site.description,
    member: [
      { "@type": "Person", name: "Shubham Jadhav" },
      { "@type": "Person", name: "Suryabhan Singh" },
      { "@type": "Person", name: "Lily Singhal" },
      { "@type": "Person", name: "Mohit Mittal" },
    ],
    ...(site.email
      ? {
          contactPoint: {
            "@type": "ContactPoint",
            email: site.email,
            contactType: "sales",
            areaServed: "Global",
          },
        }
      : {}),
    ...(site.sameAs.length ? { sameAs: site.sameAs } : {}),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <AboutView />
    </>
  );
}
